import Upsells from "./upsellLayoutSelector";

export default Upsells;
